import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, DollarSign, Clock, Package, Users, Plus } from 'lucide-react';
import { DashboardNav } from '../components/dashboard/DashboardNav';
import { StatCard } from '../components/dashboard/StatCard';
import { SalesChart } from '../components/dashboard/SalesChart';
import { RecentOrders } from '../components/dashboard/RecentOrders';
import { PopularProducts } from '../components/dashboard/PopularProducts';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import { Button } from '../components/ui/Button';
import { formatZAR } from '../utils/currency';
export function AdminDashboard() {
  const {
    user
  } = useAuth();
  const {
    orders,
    products
  } = useData();
  // Calculate stats
  const totalRevenue = orders.reduce((sum, order) => sum + order.total, 0);
  const todayOrders = orders.filter(o => new Date(o.date).toDateString() === new Date().toDateString()).length;
  const pendingOrders = orders.filter(o => o.status === 'Pending').length;
  const totalProducts = products.length;
  return <div className="min-h-screen bg-rose-50/30 flex" data-id="element-1302">
      <DashboardNav data-id="element-1303" />

      <main className="flex-1 p-4 lg:p-8 overflow-y-auto h-screen" data-id="element-1304">
        <div className="max-w-7xl mx-auto space-y-8" data-id="element-1305">
          {/* Top Bar */}
          <header className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-1306">
            <div data-id="element-1307">
              <h1 className="text-2xl font-bold text-gray-900 font-serif" data-id="element-1308">
                Admin Dashboard
              </h1>
              <p className="text-gray-500" data-id="element-1309">
                Overview of store performance and recent activity.
              </p>
            </div>

            <div className="flex items-center space-x-4" data-id="element-1310">
              <Link to="/admin/products" data-id="element-1311">
                <Button variant="outline" size="sm" leftIcon={<Plus className="w-4 h-4" data-id="element-1313" />} data-id="element-1312">
                  Add Product
                </Button>
              </Link>
              <Link to="/admin/users" data-id="element-1314">
                <Button variant="outline" size="sm" leftIcon={<Users className="w-4 h-4" data-id="element-1316" />} data-id="element-1315">
                  Manage Users
                </Button>
              </Link>
            </div>
          </header>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1317">
            <StatCard title="Total Revenue" value={formatZAR(totalRevenue)} trend="+12.5%" trendUp={true} icon={<DollarSign size={24} data-id="element-1319" />} delay={0.1} data-id="element-1318" />
            <StatCard title="Today's Orders" value={todayOrders.toString()} trend="+8.2%" trendUp={true} icon={<ShoppingBag size={24} data-id="element-1321" />} delay={0.2} data-id="element-1320" />
            <StatCard title="Pending Orders" value={pendingOrders.toString()} trend="-2.4%" trendUp={false} icon={<Clock size={24} data-id="element-1323" />} delay={0.3} data-id="element-1322" />
            <StatCard title="Total Products" value={totalProducts.toString()} trend="+4.1%" trendUp={true} icon={<Package size={24} data-id="element-1325" />} delay={0.4} data-id="element-1324" />
          </div>

          {/* Charts Section */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1326">
            <div className="lg:col-span-2" data-id="element-1327">
              <SalesChart data-id="element-1328" />
            </div>
            <div className="lg:col-span-1" data-id="element-1329">
              <PopularProducts data-id="element-1330" />
            </div>
          </div>

          {/* Recent Orders */}
          <RecentOrders data-id="element-1331" />
        </div>
      </main>
    </div>;
}